import * as go from 'gojs';
import * as _ from 'lodash/fp';
import { shakeObject } from '../shake-objects';
import { Animatable, AnimateOptions } from './types';

export const registerAnimatable = _.curry(
  (animation: go.Animation, options: AnimateOptions, animatable: Animatable<go.GraphObject | go.Diagram, unknown>) => {
    const [object, property, start, stop] = animatable;
    animation.add(object, property, start, stop);
    if (options.forceRedraw && object instanceof go.Part) {
      setTimeout(() => {
        shakeObject(object);
      }, (options?.duration || 0) + 1);
    }
  },
);
